'use client';

// styles
import styles from './nordics.module.scss';

// types
import type { DownloadCenterContainerNordProps } from 'features/download-center/components/types';

// components
import DownloadCenterContainer from 'features/download-center/components/nordics/downloadcenter-container';
import Breadcrumb from 'components/Breadcrumb/Breadcrumb';
import Layout from 'scenes/Nordics/layout';
import { RelatedLinks } from 'components/RelatedLinks/nordics/related-links';

// utils
import { contentExists, useContent } from 'components/Page/page-hooks';

export interface DownloadCenterNordicsProps extends DownloadCenterContainerNordProps {
  metaData: MetaData;
  breadcrumbs: Content['breadcrumbs'];
  relatedLinks: RelatedLinksProps;
}

export default function DownloadCenterNordics(props: Readonly<DownloadCenterNordicsProps>) {
  const pageContent = useContent();

  if (!contentExists(pageContent)) {
    return null;
  }

  // if user calls the dlc page directly then we use the props from the server
  // if the dlc page is created in cms then we combine the props from the server
  // with the props from the tpp
  const { breadcrumbs, page, contentAreas, initialData, relatedLinks } = {
    ...props,
    ...pageContent,
  };
  return (
    <Layout>
      <Breadcrumb items={breadcrumbs} className={styles.breadcrumbs} />
      <DownloadCenterContainer page={page} contentAreas={contentAreas} initialData={initialData} />
      <RelatedLinks
        title={relatedLinks?.title}
        anchor={relatedLinks?.anchor}
        categories={relatedLinks?.categories}
      />
    </Layout>
  );
}
